import { getSessionAuthentication, rms2BasePath } from "../../common/Api";
import { ExternalImportSettings } from "./ExternalImportFileList";

export interface ImportFile {
    id: number,
    fileName: string,
    importDate: string,
    oldestImportDate: string,
    isApproved: boolean,
    totalProductQuantity: number,
    totalOrders: number,
    totalOrderedQuantity: number,
}

export async function getExternalImportFiles(): Promise<ImportFile[]> {
    try {
        const auth = getSessionAuthentication();
        const response = await fetch(rms2BasePath + 'productimports', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.token,
                'x-Cleverapps-Tenant': auth.tenantStringIdentifier
            }
        });

        if (!response.ok) {
            console.error(response);
            return [];
        } else {
            console.log(response);
        }

        const responseData = await response.json();
        return await responseData.productImports;
    } catch (e) {
        console.error(e);
        return [];
    }
}

export async function updateExternalImportRows(settings: ExternalImportSettings): Promise<void> {

    const requestBody = JSON.stringify(settings);

    try {
        const auth = getSessionAuthentication();
        const response = await fetch(rms2BasePath + 'productimports', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.token,
                'X-Cleverapps-Tenant': auth.tenantStringIdentifier
            },
            body: requestBody
        });

        if (!response.ok) {
            // TODO: Implement error toast
            console.error(response);
        } else {
            console.log(response);
        }
    } catch (e) {
        console.error(e);
        return;
    }
}


